<template>
  <div class="modal-body">
    <div v-if="!productId" class="row">
      <div class="col-md-6">
        <div class="form-group">
          <label> Category</label>
          <select
            class="form-control"
            v-model="category"
            name="category_id"
            style="width: 100%;"
          >
            <option id="category" selected value=""
              >Choose Category</option
            >
            <option
              v-for="category in categoryList"
              :key="category.category_id"
              v-bind:value="category.category_id"
              >{{ category.category_name }}</option
            >
            <option id="category-all" value=""
              >Show All</option
            >
          </select>
            <span style="color:red">{{ errors[0] }}</span>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label for="site-name">
            Product Name </label
          >
          <input
            class="form-control"
            type="text"
            id="product-name"
            v-model="searchTerm"
            autocomplete="off"
          />
        </div>
      </div>
    </div>
    <div v-if="!productId" class="row" style="height: 50vh;overflow-y: auto;margin-bottom:20px">
      <div class="col-md-12">
        <b-table id="product-table"
          hover
          :items="getList"
          :fields="fields"
          :per-page="perPage"
          :current-page="currentPage"
          selectable
          select-mode="single"
          selected-variant="primary"
          @row-selected="onRowSelected"></b-table>

        <div class="overflow-auto">
        <b-pagination
          v-model="currentPage"
          :total-rows="productRows"
          :per-page="perPage"
          aria-controls="product-table"
          hide-ellipsis
          ></b-pagination>
          </div>
      </div>
    </div>
    <div v-if="productId" class="row">
      <div class="col-md-12">
        <div class="form-group">
          <label for="site-name">
            Product Name </label
          >
          <input
            class="form-control"
            type="text"
            disabled
            id="product-name"
            v-model="productName"
            autocomplete="off"
          />
        </div>
      </div>
      <div class="col-md-6">

        <div class="col-md-6">
        <div class="form-group">
          <label for="site-name">
            Brand </label
          >
          <input
            class="form-control"
            type="text"
            disabled
            id="product-name"
            v-model="productBrand"
            autocomplete="off"
          />
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label for="site-name">
            Unit of Measure </label
          >
          <input
            class="form-control"
            type="text"
            disabled
            id="product-name"
            v-model="productUOM"
            autocomplete="off"
          />
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label for="site-name">
            Unit Price </label
          >
          <input
            class="form-control"
            type="text"
            id="product-name"
            v-model="productPrice"
            autocomplete="off"
          />
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label for="site-name">
           Quantity  </label
          >
          <input
            class="form-control"
            type="text"
            id="product-name"
            v-model="productQty"
            autocomplete="off"
          />
        </div>
      </div>
      </div>
      <div class="col-md-6">

        <div class="col-md-12">
        <h4>Last 5 purchases of this item:</h4>
        <table
          width=""
          class="table table-striped table-bordered table-hover"
        >
          <thead>
            <tr>
              <th>Date</th>
              <th>Quantity</th>
              <th>Price</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="item in recentOrders"
              :key="item.order_date"
            >
              <td>
                {{ item.order_date | dateFormat }}</td>
              <td>
                {{ item.quantity }}</td>
              <td>
                {{ item.unit_price }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12">
        <a
          v-if="!productId && selectedItems.length"
          style="margin-right: 10px;"
          v-on:click="onSubmitList()"
          class="btn btn-success  text-center  "
        >
          Submit
        </a>
        <a
          v-if="productId"
          style="margin-right: 10px;"
          v-on:click="onAddProduct()"
          class="btn btn-success  text-center  "
        >
          Add Product
        </a>
        <a
          v-if="productId"
          v-on:click="clearData()"
          class="btn btn-danger  text-center  "
        >
          Product Listing
        </a>
        <a
          v-if="!productId"
          v-on:click="$emit('hide-form')"
          class="btn btn-danger  text-center  "
        >
          Back To LPO
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import api from "../api";
import { BTable, BPagination } from "bootstrap-vue";

export default {
  name: "AddLPOProduct",
  data() {
    return {
      perPage: 10,
      currentPage: 1,
      itemId: '',
      category: '',
      searchTerm: '',
      productName: '',
      productBrand: '',
      productUOM: '',
      productPrice: 0,
      productQty: 0,
      productId: null,
      recentOrders: [],      
      errors : [],
      itemList: this.$store.state.productList,
      categoryList: [],
      selectedItems: [],
      loading: false,
      fields: ['product_name', 'brand_name', 'uom_name', 'price'] 
    };
  },
  components: {
    BTable,
    BPagination
  },
  computed: {
    getList: function () {
      const list = this.itemList.filter((el)=> {
        return (this.category !=='' && this.category !== 'all' ? el.category_id == this.category : true) && (this.searchTerm !== '' ? el.product_name.toLowerCase().includes(this.searchTerm.toLowerCase()): true);
      });
      return list;
    },
    productRows: function () {
      return this.getList.length;
    }
  },
  methods: {
    clearData: function () {
      this.productName = '';
      this.productBrand = '';
      this.productUOM = '';
      this.productPrice = '';
      this.productQty = 0;
      this.productId = null;
    },
    onRowSelected: function (items) {
      console.log('Selected Product:', items);
      this.productName = items[0].product_name;
      this.productBrand = items[0].brand_name;
      this.productUOM = items[0].uom_name;
      this.productPrice = items[0].price;
      this.productQty = 1;
      this.productId = items[0].product_id;
      this.getRecentPurchases();
    },
    onAddProduct: function () {
      const productItem = {
        product_id: this.productId,
        quantity: this.productQty,
        price: this.productPrice,
        uom: this.productUOM,
        sub_total: this.productQty * this.productPrice,
        product_name: this.productName 
      }
      // this.$emit('add-product', productItem);
      this.selectedItems.push(productItem);
      this.clearData();
    },
    onSubmitList: function () {
      this.$emit('add-product', this.selectedItems);
    },
    getRecentPurchases: function() {
      const list = {
        filter: {
          'product_id': this.productId,
          'order_by_date': true,
          'limit': 5
        },
      };
      api
        .request("post", "GeneralApis/get_recent_order_items", list)
        .then((response) => {
          var data = response.data;
          console.log(data);
          if (data.errorcode) {
            this.recentOrders = response.data.values;
          } else {
            this.recentOrders = data.itemList;
          }
        });
    },
    getProducts: function() {
      const list = {
        filter: {
          'product_name': this.searchTerm,
          'category_id': this.category
        },
      };
      api
        .request("post", "GeneralApis/get_products", list)
        .then((response) => {
          var data = response.data;
          console.log(data);
          if (data.errorcode) {
            this.itemList = response.data.values;
          } else {
            this.itemList = data.productList;
          }
        });
    },
    getCategory: function() {
      const list = {
        filter: {
        },
      };
      api
        .request("post", "GeneralApis/get_category", list)
        .then((response) => {
          var data = response.data;
          console.log(data);
          if (data.errorcode) {
            this.categoryList = response.data.values;
          } else {
            this.categoryList = data.categoryList;
          }
        });
    },
  },
  filters: {
    dateFormat: function(date) {
      var options = {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
      };
      var formatdate = new Date(date);
      var dateformat = formatdate.toLocaleDateString("en-US", options);
      return dateformat;
    }
  },
  mounted() {
    this.getProducts();
    this.getCategory();
  },
};
</script>

<style scoped>
td {
  cursor: pointer;
}
</style>
